import React, { useEffect, useState } from "react";
import { useParams, Link, useNavigate } from "react-router-dom";
import { ArrowLeft, Loader2 } from "lucide-react";
import api, { resolveImg } from "../api";
import { brand, HERO_IMAGE } from "../mock";
import { Footer } from "./BlogHome";
import Comments from "./Comments";

export default function BlogPost() {
  const { id } = useParams();
  const navigate = useNavigate();
  const [post, setPost] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);

  useEffect(() => {
    setLoading(true);
    api.get(`/posts/${id}`).then((r) => setPost(r.data)).catch(() => setError(true)).finally(() => setLoading(false));
  }, [id]);

  return (
    <div className="min-h-screen" style={{ backgroundColor: "#141414", color: "#f5f5f5", fontFamily: 'Lora, Georgia, serif' }}>
      <header className="sticky top-0 z-20 bg-[#141414]/95 backdrop-blur border-b border-[#2a2a2a]">
        <div className="max-w-5xl mx-auto px-6 py-4 flex items-center justify-between">
          <Link to="/" className="uppercase font-semibold tracking-[0.15em] text-lg" style={{ fontFamily: 'Oswald, sans-serif' }}>
            Corner Office <span className="text-[#e63946]">Curmudgeon</span>
          </Link>
          <button onClick={() => navigate("/")} className="flex items-center gap-1.5 text-sm text-gray-300 hover:text-[#e63946] transition-colors">
            <ArrowLeft className="w-4 h-4" /> All grumbles
          </button>
        </div>
      </header>

      {loading ? (
        <div className="flex justify-center py-24"><Loader2 className="w-8 h-8 animate-spin text-[#e63946]" /></div>
      ) : error || !post ? (
        <div className="max-w-3xl mx-auto px-6 py-24 text-center text-gray-400">This grumble could not be found.</div>
      ) : (
        <>
          <section className="relative">
            <img src={post.image_url ? resolveImg(post.image_url) : HERO_IMAGE} alt={post.title} className="w-full object-cover max-h-[420px]" />
            <div className="absolute inset-x-0 bottom-0 h-24" style={{ background: "linear-gradient(to top, #141414, transparent)" }} />
          </section>

          <article className="max-w-3xl mx-auto px-6 py-14">
            {post.subtitle && <p className="uppercase tracking-[0.3em] text-[#e63946] text-xs mb-3" style={{ fontFamily: 'Oswald, sans-serif' }}>{post.subtitle}</p>}
            <h1 className="text-4xl md:text-6xl font-bold uppercase leading-[1.05] mb-8" style={{ fontFamily: 'Oswald, sans-serif' }}>{post.title}</h1>
            <div className="coc-content" dangerouslySetInnerHTML={{ __html: post.content_html }} />
          </article>
          <Comments postId={post.id} />
        </>
      )}

      <Footer />
    </div>
  );
}
